<template>
    <div class="h-full w-full flex flex-col">
        <ProjectForm mode="edit" :selected-item="selectedItem" @created="onUpdated" @close="$emit('close')" />
    </div>
</template>

<script>
import ProjectForm from "./form.vue";
export default {
    name: "project-edit",
    emits: ["created", "close"],
    props: ["selectedItem"],
    components: { ProjectForm, },
    methods: {
        onUpdated(msg) {
            this.$emit('updated', msg);
        }
    },
}
</script>